/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { MappingId } from "../../../commons/types/MappingId";
export const DeleteMultipleRulesRequest = core.serialization.object({
    ruleIds: core.serialization.list(MappingId),
});
